<template>
  <div id="settlementDialog">
    <el-dialog
      title=""
      custom-class='innerPageDialog'
      @close="OnClose"
      top="0"
      :modal='false'
      width="100%"
      :visible.sync="visible"
    >
      <div class="opreationBox opreationOtherName">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          label-width="100px"
        >
          <el-form-item label="结算金额：">
            <span>{{desObj.settlementPrice}}元</span>
          </el-form-item>
          <el-form-item label="结算类型：">
            <span>{{desObj.settlementType}}</span>
          </el-form-item>
          <el-form-item label="是否充值：">
            <span
              v-if="isRecharge==0"
              style="color: rgb(245, 108, 108);"
            >未充值</span>
            <span
              v-if="isRecharge==1"
              style="color: rgb(103, 194, 58);"
            >已充值</span>
          </el-form-item>
          <el-form-item
            label="明细类型"
            label-width="100px"
          >
            <el-select
              v-model="formInline.detailType"
              placeholder="请选择明细类型"
              @change="handleCurrentChange(1)"
            >
              <el-option
                v-for="item in detailTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            label-width="0"
          >
            <el-button
              type="primary"
              :disabled="isRecharge==1"
              @click="updateRecharge"
            >确定充值</el-button>
            <el-button
              @click="OnClose"
              type="primary"
            >关闭详情</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableBox">
        <el-table
          v-loading="loading"
          :height="tableH"
          :data="desList"
          border
          style="width: 100%"
        >
          <el-table-column
            fixed
            width="200"
            header-align="center"
            align="left"
            prop="qTitle"
            label="问卷名称 "
          >
          </el-table-column>
          <el-table-column
            width="180"
            header-align="center"
            align="center"
            prop="qid"
            label="问卷ID "
          >
          </el-table-column>
          <el-table-column
            width="100"
            header-align="center"
            align="center"
            label="完成用户"
          >
            <template slot-scope="scope">
              <span
                v-if="formInline.detailType==0"
                :key="Math.ceil(Math.random()*10000)"
                v-text="scope.row.user?scope.row.user.name:''"
              ></span>
              <span
                v-if="formInline.detailType==1"
                :key="Math.ceil(Math.random()*10000)"
                v-text="scope.row.name?scope.row.name:''"
              ></span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            label="用户手机号"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.user.mobilePhone}}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="receivePrice"
            label="理论报酬 "
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="actualPrice"
            label="实际报酬"
          >
          </el-table-column>
          <el-table-column
            :key="Math.ceil(Math.random()*10000)"
            v-if="formInline.detailType==0"
            header-align="center"
            align="center"
            label="完成状态"
          >
            <template slot-scope="scope">
              <template v-for="(item,index) in FinishStateList">
                <span
                  :key="index"
                  :style="{color:item.color}"
                  v-if="item.value==scope.row.finishState"
                >{{ item.label}}</span>
              </template>
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            header-align="center"
            align="center"
            label="是否已提现"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.hasRecieve?'已提现':'未提现'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            header-align="center"
            align="center"
            label="提现时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.recieveTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :key="Math.ceil(Math.random()*10000)"
            v-if="formInline.detailType==0"
            width="180"
            header-align="center"
            align="center"
            label="开始时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            :key="Math.ceil(Math.random()*10000)"
            v-if="formInline.detailType==0"
            header-align="center"
            align="center"
            label="完成时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.finishTime}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="shareUserName"
            label="分享人"
          >
          </el-table-column> -->
        </el-table>
      </div>
      <div class="pageBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObj.PageIndex"
          :page-sizes="[2, 4, 10, 20, 50, 100]"
          :page-size="pageObj.PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObj.total"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLaunchDetails,
  getShareDetails,
  updateRechargeState,
} from 'api/request'
import { SetTableH } from '../../../utils/utils'
export default {
  props: {
    showDes: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    desObj: {
      type: Object,
      default: function () {
        return null
      },
    },
  },
  data() {
    return {
      loading: true,
      visible: this.showDes,
      tableH: '250',
      dataObj: null,
      isRecharge: 0,
      formInline: {
        detailType: 0,
      },
      detailTypeList: [
        {
          value: 0,
          label: '非分享明细',
          color: '',
        },
        {
          value: 1,
          label: '分享明细',
          color: '',
        },
      ],
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10,
      },
      FinishStateList: [
        {
          value: -1,
          label: '全部',
          color: '',
        },
        {
          value: 0,
          label: '未完成',
          color: '',
        },
        {
          value: 1,
          label: '被甄别',
          color: '',
        },
        {
          value: 2,
          label: '完成',
          color: '',
        },
        {
          value: 3,
          label: '完成但名额超出',
          color: '',
        },
      ],
      desList: [],
    }
  },
  watch: {
    showDes: {
      immediate: true,
      handler(showDes) {
        this.visible = this.showDes
      },
    },
    desObj: {
      handler(newValue, oldValue) {
        console.log(newValue)
      },
      deep: true,
    },
  },
  components: {},
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      if (this.formInline.detailType == 0) {
        this.getDesList()
      } else {
        this.getShareDesList()
      }
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      if (this.formInline.detailType == 0) {
        this.getDesList()
      } else {
        this.getShareDesList()
      }
    },
    async getDesList() {
      let params = {
        settlementID: this.desObj.id,
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
      }
      this.loading = true
      let data = await getLaunchDetails(params)
      if (data) {
        console.log(data)
        this.desList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    async getShareDesList() {
      let params = {
        settlementID: this.desObj.id,
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
      }
      this.loading = true
      let data = await getShareDetails(params)
      if (data) {
        this.desList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    async updateRecharge() {
      this.$confirm(
        `请你确定卡里有足够金额支付这次结算，是否继续进行充值操作?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          updateRechargeState(this.desObj.id).then((data) => {
            if (data) {
              this.$message({
                message: '已充值成功',
                type: 'success',
              })
              this.isRecharge = 1
              this.$parent.handleCurrentChange(1)
            } else {
              this.$message({
                message: '充值失败',
                type: 'error',
              })
            }
          })
        })
        .catch(() => {})
    },
    OnClose() {
      this.$emit('update:showDes', false)
    },
  },
  mounted() {
    SetTableH(this, '.opreationOtherName')
    this.isRecharge = this.desObj.isRecharge
  },
  created() {
    this.getDesList()
  },
}
</script>
<style lang='scss'>
#settlementDialog {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
  .el-dialog__wrapper {
    position: fixed;
    top: 60px;
    right: 0;
    bottom: 0;
    left: 210px;
    overflow: auto;
    margin: 0;
    z-index: 99 !important;
    .innerPageDialog {
      margin: 0;
      height: 100%;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 20px;
        height: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
